import { Injectable } from '@angular/core';
import { ProcessedProduct } from './product-capabilities.service';
import { ProductCart } from '@models';

export interface ProductCartWithEngraving extends ProductCart {
  varianceSelections?: {
    options?: {
      selectedValue?: string;
    }[];
  };
  varianceSelectionsJson?: string;
}
@Injectable({
  providedIn: 'root'
})
export class EngravingUtilitiesService {

  /**
   * Extract engraving text from a product
   */
  getEngravingText(product: ProductCartWithEngraving | any): string | null {
    // Check for variantSelection (order API structure)
    if ((product as any).variantSelection?.options) {
      const engravingOption = (product as any).variantSelection.options.find(
        (opt: any) => opt.name === 'Engraving'
      );
      if (engravingOption?.selectedValue) {
        return engravingOption.selectedValue;
      }
    }
    // Check for varianceSelections (cart structure)
    if (product.varianceSelections?.options?.[0]?.selectedValue) {
      return product.varianceSelections.options[0].selectedValue;
    }
    // Check for varianceSelectionsJson (fallback)
    if (product.varianceSelectionsJson) {
      try {
        const selections = JSON.parse(product.varianceSelectionsJson);
        const text = selections.Options?.[0]?.SelectedValue;
        if (text) {
          return text;
        }
      } catch (e) {
        console.error("Failed to parse varianceSelectionsJson", e);
      }
    }
    return null;
  }

  /**
   * Check if a product has engraving text
   */
  hasEngraving(product: ProcessedProduct): boolean {
    return !!(product.engravingText && product.engravingText.trim().length > 0);
  }

  /**
   * Create engraving details map from cart products
   */
  createEngravingDetailsMap(products: ProductCartWithEngraving[]): Map<string, string | null> {
    const map = new Map<string, string | null>();
    
    if (products) {
      for (const product of products) {
        const engravingText = this.getEngravingText(product);
        map.set(product.productId.toString(), engravingText);
      }
    }
    
    return map;
  }
}